import { render, staticRenderFns } from "./keyword-blacklist-add.vue?vue&type=template&id=9eb2e342&"
import script from "./keyword-blacklist-add.vue?vue&type=script&lang=js&"
export * from "./keyword-blacklist-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9eb2e342')) {
      api.createRecord('9eb2e342', component.options)
    } else {
      api.reload('9eb2e342', component.options)
    }
    module.hot.accept("./keyword-blacklist-add.vue?vue&type=template&id=9eb2e342&", function () {
      api.rerender('9eb2e342', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/content-manage/keyword-blacklist/keyword-blacklist-add.vue"
export default component.exports